import { GET_POLICY_TEST_OVERRIDE } from '../../constants/actions/policy';

export function getPolicyTestOverride(payload) {
    return {
        type: GET_POLICY_TEST_OVERRIDE,
        payload,
    };
}
